// Unidad con la que se escribe una medida de la guía de talles de Mercado Libre.
// Centímetros si la ficha los ofrece: Mercado Libre puede listar antes las pulgadas (prueba en vivo del 5/10,
// ADR-2026-10-05-ficha-ml-prueba-en-vivo-front).
export function unidadDeLaGuia(unidades: string[]): string | undefined {
  return unidades.includes('cm') ? 'cm' : unidades[0];
}

/**
 * La opción de una lista cerrada (el "talle para filtrar" de Mercado Libre) que corresponde a un talle: "s" → "S".
 * Mercado Libre la exige en cada fila de la guía; así la persona no la elige a mano (prueba en vivo del 5/10).
 */
export function opcionDelTalle<T extends { nombre: string }>(opciones: T[], talle: string): T | undefined {
  const plano = (x: string) => x.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toUpperCase();
  const t = plano(talle);
  return opciones.find((o) => plano(o.nombre) === t);
}

/** El "talle para filtrar" de Mercado Libre (FILTRABLE_SIZE, o `<DOMINIO>_FILTRABLE_SIZES`). */
export function esTalleParaFiltrar(id: string): boolean {
  return /(^|_)FILTRABLE_SIZES?$/.test(id);
}
